// Shared bilingual labels for the plan feature matrix (keys must match backend FEATURE_KEYS).
export const FEATURE_LABELS = {
  directory: { es: "Directorio", en: "Directory" },
  gallery: { es: "Galería", en: "Gallery" },
  clients: { es: "Clientes", en: "Clients" },
  invoicing: { es: "Facturación", en: "Invoicing" },
  projects: { es: "Proyectos", en: "Projects" },
  client_progress: { es: "Progreso del cliente", en: "Client progress" },
  receivables: { es: "Cuentas por cobrar", en: "Accounts receivable" },
  accounting: { es: "Contabilidad", en: "Accounting" },
  employees: { es: "Empleados", en: "Employees" },
  timesheets: { es: "Horas", en: "Timesheets" },
  payroll: { es: "Nómina", en: "Payroll" },
  business_site: { es: "Página web del negocio", en: "Business website" },
};

// Short bilingual explanations for the pricing glossary.
export const FEATURE_DESCRIPTIONS = {
  directory: { es: "Aparece en el directorio público de URBIS para que los clientes te encuentren.", en: "Get listed in the public URBIS directory so customers can find you." },
  gallery: { es: "Muestra fotos de tus trabajos terminados en tu perfil.", en: "Show photos of your finished work on your profile." },
  clients: { es: "Guarda y administra tu cartera de clientes en un solo lugar.", en: "Save and manage your client list in one place." },
  invoicing: { es: "Crea y envía facturas profesionales con tu logo y marca.", en: "Create and send professional invoices with your logo and brand." },
  projects: { es: "Organiza cada trabajo por etapas y haz seguimiento del avance.", en: "Organize each job by stages and track its progress." },
  client_progress: { es: "Comparte con el cliente el avance del trabajo mediante un enlace seguro.", en: "Share job progress with the client through a secure link." },
  receivables: { es: "Lleva el control de pagos pendientes y cobrados.", en: "Keep track of pending and collected payments." },
  accounting: { es: "Consulta ingresos, gastos y un resumen contable de tu negocio.", en: "See income, expenses and an accounting summary of your business." },
  employees: { es: "Registra a tu equipo y asígnale trabajos.", en: "Register your team and assign them jobs." },
  timesheets: { es: "Registra las horas trabajadas por cada empleado.", en: "Log the hours worked by each employee." },
  payroll: { es: "Calcula los pagos de nómina de tu equipo automáticamente.", en: "Automatically calculate your team's payroll." },
  business_site: { es: "Tu propia página web dentro de URBIS con servicios, horarios y contacto.", en: "Your own website within URBIS with services, hours and contact." },
};
